import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var configGamesDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var CURRENCY_COLUMN_INDEX = {
    Code: 0,
    Name: 1,
    PlayForFunAmount: 2,
    Status: 3,
    FilterButtons: 4
};

var GAME_COLUMNS_INDEX = {
    Id: 0,
    GameName: 1,
    Currency: 2,
    FilterButtons: 3
};

var FILTER_DELIM = '-delim-';
var btnCancelSearchId = 'btnCancelSearch';
var btnCancelSearchFrbConfigsId = 'btnCancelSearchFrbGamesConfigs';

export interface DetailPageOptions extends PageOptionsBase {
    dataSwitch: string;
    urlList: string;
    urlDetail: string;
    urlChangeFrbConfigStatus: string;
    urlGameConfigurations: string;
    urlCopy: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
        GameConfigurations: string;
    }
}

export class DetailPage extends PageBase<DetailPageOptions> {

    private static rolesInit: string;
    private static msApi: MultiSelectApi;

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    private _filterCurrencyCode: JQuery;
    private _filterCurrencyName: JQuery;

    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _btnCancelSearchFrbGamesConfigs: JQuery;

    private _filterGame: MultiSelectApi;
    private _filterCurrency: MultiSelectApi;

    private _chckAllConfigs: JQuery;
    private _copyUrl: string;
    private _btnCopyCurrencies: JQuery;

    constructor(options: DetailPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);
        var getGameConfigurationUrl = (rowData: any): string => (`${options.urlGameConfigurations}?operationId=${rowData.Id}`);

        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.createdRowCurrency = this.createdRowCurrency.bind(this);
        this.preDrawFrbConfigCallback = this.preDrawFrbConfigCallback.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.cancelFrbGamesConfigsSearch = this.cancelFrbGamesConfigsSearch.bind(this);
        this.enableFrbConfigurationMulti = this.enableFrbConfigurationMulti.bind(this);
        this.disableFrbConfigurationMulti = this.disableFrbConfigurationMulti.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);        
        this.setSelectAllConfigCheckbox = this.setSelectAllConfigCheckbox.bind(this);
        this.copyCurrencies = this.copyCurrencies.bind(this);

        window['setSelectAllConfigCheckbox'] = this.setSelectAllConfigCheckbox;

        if (options.dataSwitch === "currency") {
            this._copyUrl = this._options.urlCopy;
            this._tableId = "tableCurrencies";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDom,
                rowId: 'Id',
                autoWidth: true,
                lengthMenu: [[10, 20, 100, -1], [10, 20, 100, "All"]],
                ordering: true,
                columns: [
                    {
                        data: 'Currency.Code',
                        className: "bold",
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkCode${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                    },
                    {
                        data: 'Currency.Name'
                    },
                    {
                        data: 'PlayForFunAmount'
                    },
                    {
                        data: "IsEnabled",
                        sortable: false,
                        render: (data: any, type: any, rowData: any) => {
                            var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                            var css = data === true ? 'status-enabled' : 'status-disabled';
                            return `<span id='spnState${rowData.Id}' class='${css}'>${text}</span>`;
                        }
                    },
                    {
                        data: '',
                        sortable: false,
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                    }
                ],
                order: [[CURRENCY_COLUMN_INDEX.Code, "asc"]],
                callbacks: {
                    preDrawCallback: this.preDrawCallback,
                    createdRow: this.createdRowCurrency
                }
            };
        }

        if (options.dataSwitch === "operation") {
            this._tableId = "tableOperations";
                this._tableOptions = {
                    url: this._options.urlList,
                    dom: tableDom,
                    rowId: 'Id',
                    autoWidth: true,
                    ordering: false,
                    pageLength: 100,
                    lengthMenu: [[20, 100, 200, -1], [20, 100, 200, "All"]],
                    columns: [
                        {
                            data: 'Name',
                            className: "bold",
                            render: (data: any, type: any, rowData: any) =>
                                (`<a id='lnkName${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                        },
                        {
                            data: "Code",
                            render: (data: any, type: any, rowData: any) =>
                                (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                        },
                        {
                            data: "Status",
                            render: (data: any, type: any, rowData: any) => {
                                //var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                                var css = `status-${data.toLowerCase()}`;
                                return `<span id='spnState${rowData.Id}' class='${css}'>${data}</span>`;
                            }
                        },
                        {
                            data: "Description",
                            defaultContent: '',
                            render: (data: any, type: any, rowData: any) =>
                                (`<span id='spnDescription${rowData.Id}'>${Utils.valueOrDefault(data, '')}</span>`)
                        },
                        {
                            data: '',
                            render: (data: any, type: any, rowData: any) =>
                                (`<a id='lnkGameConfigurations${rowData.Id}' href='${getGameConfigurationUrl(rowData)}'>${options.localizer.GameConfigurations}</a>`)
                        }
                    ]
                };
        }
        // === prepare table options

        // ReSharper disable once StringLiteralTypo
        if (options.dataSwitch === "frbgameconfig") {
            this._tableId = "tableFreeRoundGamesConfigurations";
            this._tableOptions = {
                url: this._options.urlList,
                dom: configGamesDom,
                rowId: 'Id',
                autoWidth: true,
                ordering: true,
                pageLength: 100,
                lengthMenu: [[10, 20, 50, 100, 1000], [10, 20, 50, 100, 1000]],
                columns: [
                    {
                        data: 'Id',
                        render: (data: any, type: any, rowData: any) =>
                            (`<input id='chckbx${rowData.Id}' name='selectedFrbConfig' value='${rowData.Id}' type='checkbox' onClick="setSelectAllConfigCheckbox()" />`)
                    },
                    {
                        data: "GameName",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameName${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "CurrencyCode",
                        defaultContent: '',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnCurrencyCode${rowData.Id}'>${Utils.valueOrDefault(data, '')}</span>`)
                    },
                    {
                        data: "Status",
                        defaultContent: '',
                        render: (data: any, type: any, rowData: any) => {
                            var text = data ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                            var css = data ? 'status-enabled' : 'status-disabled';
                            return `<span id='spnLockState${rowData.Id}' class='${css}'>${text}</span>`;
                        }
                    },
                    {
                        data: '',
                        sortable: false,
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                    }
                ],
                order: [[GAME_COLUMNS_INDEX.Id, "asc"]],
                callbacks: {
                    preDrawCallback: this.preDrawFrbConfigCallback
                }
            };
        }
    }

    init(): void {
        DetailPage.msApi = new MultiSelectApi('roles');
        DetailPage.rolesInit = DetailPage.msApi.getSelectionValues();
        this._form = Utils.getJQueryById("form" + this._tableId);
        this._btnCancelSearch = Utils.getJQueryById(btnCancelSearchId);
        this._btnCancelSearchFrbGamesConfigs = Utils.getJQueryById(btnCancelSearchFrbConfigsId);
        this._filterCurrencyCode = Utils.getJQueryById('filterCode');
        this._filterCurrencyName = Utils.getJQueryById('filterName');
        this._filterGame = new MultiSelectApi('filterGame');
        this._filterCurrency = new MultiSelectApi('filterCurrency');
        this._chckAllConfigs = Utils.getJQueryById("frbConfigurationsSelectAll");
        this._chckAllConfigs.on("change", this.checkBoxAll);

        // Free round configurations Enable/Disable buttons:
        const btnEnableMulti = Utils.getJQueryById("btnEnableMulti");
        const btnDisableMulti = Utils.getJQueryById("btnDisableMulti");
        this._btnCopyCurrencies = Utils.getJQueryById("btnCopyCurrencies");
        btnEnableMulti.on("click", this.enableFrbConfigurationMulti);
        btnDisableMulti.on("click", this.disableFrbConfigurationMulti);
        this._btnCopyCurrencies.on("click", this.copyCurrencies);

        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);

        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);

        // cancel Free Round Game Configurations search click -> reset filter row values
        this._btnCancelSearchFrbGamesConfigs.on('click', this.cancelFrbGamesConfigsSearch);
    }

    public static showForm(field: string, focusField: string) {
        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterCurrencyCode.val('');
        this._filterCurrencyName.val('');
    }

    private cancelFrbGamesConfigsSearch(e: JQueryEventObject): void {
        this._filterCurrency.selectAll();
        this._filterGame.selectAll();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllConfigs[0]).checked = false;
        var filterCurrencyCode = this._filterCurrencyCode.val();
        datatable.columns(CURRENCY_COLUMN_INDEX.Code).search(filterCurrencyCode);

        var filterCurrencyName = this._filterCurrencyName.val();
        datatable.columns(CURRENCY_COLUMN_INDEX.Name).search(filterCurrencyName);

        return true;
    }

    private createdRowCurrency(row: Node, data: any[] | Object, dataIndex: number): void {
        if (data["IsEnabled"]) {
            this._btnCopyCurrencies.removeAttr("disabled");
        }
    }

    private preDrawFrbConfigCallback(datatable: DatatableApi): any {

        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(GAME_COLUMNS_INDEX.GameName).search(filterGame);

        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        datatable.columns(GAME_COLUMNS_INDEX.Currency).search(filterCurrency);

        return true;
    }
    
    public static hideForm(field: string) {
        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        DetailPage.msApi.setSelectionValues(DetailPage.rolesInit);

        $(label).closest(".form-group").removeClass("gray");
    }

    private enableFrbConfigurationMulti(e: JQueryEventObject) {
        this.changeFrbConfigurationStatusMulti(e, true);
    }

    private disableFrbConfigurationMulti(e: JQueryEventObject) {
        this.changeFrbConfigurationStatusMulti(e, false);
    }

    private changeFrbConfigurationStatusMulti(e: JQueryEventObject, status: boolean) {
        e.preventDefault();
        var urlPost = this._options.urlChangeFrbConfigStatus;
        var ids = $("input[name='selectedFrbConfig']:checked").map(function () {
            return $(this).val();
        });
        $.ajax({
            async: false,
            url: urlPost,
            type: "POST",
            dataType: 'json',
            data: { configIds: ids.get(), status: status },
            success: function (data) {
                window.location.href = data;
            }
        });
    }

    private setSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        var checkboxes = $(checkboxesIdentifier);
        let gamesSelectAll = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(gamesSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>gamesSelectAll).checked = allCheckboxesChecked;
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedFrbConfig']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllConfigs[0]).checked;
        }
    }

    private setSelectAllConfigCheckbox(): void {
        this.setSelectAllCheckbox("frbConfigurationsSelectAll", "input[name='selectedFrbConfig']");
    }

    private copyCurrencies(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._copyUrl;
        $.ajax({
            async: false,
            url: urlPost,
            type: "POST",
            dataType: 'json',
            success: function (data) {
                let textToCopy = $('#currenciesClipboard');
                textToCopy.attr("type", "text");
                textToCopy.val(data);
                textToCopy.select();
                document.execCommand("copy");
                textToCopy.attr("type", "hidden");
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/DetailPage.ts
 **/